import React, { useEffect, useState } from 'react';
import useAxios from 'hooks/useAxios';
import { currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import { ModuleAccess } from 'utils/moduleaccess';
let tableDataBackup = [],
  rowForEdit = {},
  selectedCoveredEntity = null;
let editPhoneNumber = false;

const ProvidersTable = (props) => {
  const {
    data,
    totalSize,
    onPageChange,
    apiFilter,
    formReset,
    onSearchColumnFilters = () => '',
    onExport,
    setLoading,
    refetch,
    coveredEntityTenantID,
    researchNeededCount,
    eligibleCount,
    inEligibleCount
  } = props;
  selectedCoveredEntity = coveredEntityTenantID;

  tableDataBackup = data;
  const API = useAxios();
  const [filters, setFilters] = useState(apiFilter);
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  useEffect(() => {
    setHasExportPermission(ModuleAccess("PRD", "EXP"));
  }, []);

  useEffect(() => {
    setFilters(apiFilter);
  }, [apiFilter]);

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  useEffect(() => {
    setReset((pre) => !pre);
    setFilters({
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    });
  }, [formReset]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const saveUpdateRow = async () => {
    setLoading(true);
    const tenantID = selectedCoveredEntity;
    let payload = { ...rowForEdit };
    payload.suppressFlag =
      payload.suppressFlag === null ? 'N' : payload.suppressFlag;
    payload.eligibleFlag =
      payload.eligibleFlag === null ? 'N' : payload.eligibleFlag;
    delete payload.isEdit;
    try {
      const result = await API.post(`/${tenantID}/CEProvider/update`, payload);
      if (result) {
        setLoading(false);
        //refetch();
        if (onSearchColumnFilters) {
          onSearchColumnFilters(filters);
        }
      }

      let param = {};
      param.CoveredEntityId = payload.coveredEntityID;
      param.ActionType = "ProviderResearchNeeded";
      const { data } = await API.post(
        `Dashboard/${tenantID}/Taskboard/updatetaskboard`,
        param
      );

    } catch (error) {
      setLoading(false);
    }
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.providerID === rowData?.providerID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellRenderEdit = (row) => {
    if (ModuleAccess("PRD", "ED")) {
      return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} />;
    }
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        formatterType={formatterType}
        onChange={updateRowValue}
        editPhoneNumber={editPhoneNumber}
      />
    );
  };

  let columns = [
    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'providerNPI',
      text: 'NPI#',
      sort: true,
      width: 90,
      show: true,
      inputType: 'text',
    },
    {
      dataField: 'providerFirstName',
      text: 'Provider First Name',
      sort: true,
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: 'providerLastName',
      text: 'Provider Last Name',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: 'eligibleFlag',
      text: 'Eligible Flag',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col, 'checkbox', true),
      edit: true,
    },
    {
      dataField: 'comments',
      text: 'Comments',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col, 'textarea'),
      edit: true,
    },
    {
      dataField: 'faxNumber',
      text: 'Fax Number',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: 'phoneNumber',
      text: 'Phone Number',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col, 'number'),
      edit: true,
    },
    {
      dataField: 'suppressFlag',
      text: 'Suppress Flag',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col, 'checkbox', true),
      edit: true,
    },

    {
      dataField: 'providerSpecialty',
      text: 'Provider Specialty',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: 'opportunityAmount',
      text: 'Opportunity Amount',
      sort: true,
      width: 120,
      show: true,
      inputType: 'number',
      cellRenderer: (row) => currencyFormat(row.opportunityAmount),
    },
    {
      dataField: 'opportunityCount',
      text: 'Opportunity Count',
      sort: true,
      width: 120,
      show: true,
      inputType: 'number',
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: 'source',
      text: 'Source',
      sort: false,
      width: 120,
      show: true,
      hideColFilter: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: 'createdBy',
      text: 'Created By',
      sort: false,
      width: 120,
      show: true,
      hideColFilter: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: 'createdDate',
      text: 'Created Date',
      sort: false,
      width: 120,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, 'date'),
    },
    {
      dataField: 'modifiedBy',
      text: 'Modified By',
      sort: false,
      width: 120,
      show: true,
      hideColFilter: true,
      inputType: 'text',
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: 'modifiedDate',
      text: 'Modified Date',
      sort: false,
      width: 120,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, 'date'),
    },
  ];

  const onHandleSort = (filter, hasColFilter) => {
    setFilters(filter);
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setFilters(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setFilters(filter);
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setFilters(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setFilters(filter);
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setFilters(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };

  return (
    <div
      className='table-card scroll-table position-relative border-0 rounded pt-0'
      fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='providers-table'
        fixedColumn
        columns={columns}
        data={tableData}
        handleSort={onHandleSort}
        reset={reset}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        onPageSizeChange={onPageSizeChange}
        onExport={onExport}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={filters.currentPage}
        totalRecords={totalSize}
        filters={filters}
        pageSize={filters.pageSize}
        hasNoEligibility={false}
        researchNeededCount={researchNeededCount}
        eligibleCount={eligibleCount}
        inEligibleCount={inEligibleCount}
        hasExportPermission={hasExportPermission}
      />
    </div>
  );
};
export default ProvidersTable;
